import HttpService from "./HttpService";

let usuarioServie = {
  usuariosCemicloud: (props, search) => {
    return HttpService.backApi.get(`/usuario/cemicloud?search=${search}&page=${props.page - 1}&size=${props.itemsPerPage}`);
  },
  consultarCemicloudPorId: (id) => {
    return HttpService.backApi.get(`/usuario/cemicloud/${id}`);
  },
  trocarSenha: (body) => {
    return HttpService.backApi.post("/usuario/trocar-senha", body);
  },
  trocarSenhaDeOutroUsuario: (body) => {
    return HttpService.backApi.post(`/usuario/trocar-senha/${body.cdUsuario}`, body);
  },
  buscarPaginado: (props, search) => {
    return HttpService.backApi.get(
      `/usuario/by-owner/paginated?page=${props.page - 1}&size=${props.itemsPerPage}&search=${search}&sort=${
        props.order
      }`
    );
  },
  create: (usuario) => {
    return HttpService.backApi.post("/usuario", usuario);
  },
  update: (usuario) => {
    return HttpService.backApi.put(`/usuario/${usuario.cdUsuario}`, usuario);
  },
  updateUsuario: (body) => {
    return HttpService.backApi.post("/usuario/update", body);
  },
  buscarDados: () => {
    return HttpService.backApi.get("/usuario/dados");
  },
  changeOwner: (cdOwner) => {
    return HttpService.backApi.post(`/usuario/change-owner?cdOwner=${cdOwner}`);
  },
  consultarPorId: (id) => {
    return HttpService.backApi.get(`/usuario/${id}`);
  },
  buscarUsuariosByOwner: (cdOwner) => {
    return HttpService.backApi.get(`/usuario/by-owner/${cdOwner}`);
  },
};

export default usuarioServie;
